module.exports = __webpack_public_path__ + "static/img/authorize-img.910ed1d0.png";